import * as ReactDOMClient from 'react-dom/client';
import { unstableSetRender } from 'antd-mobile/es/utils/unstable-render';

const containerRootMap = new WeakMap();

function mountWithRoot(node, container) {
  let root = containerRootMap.get(container);
  if (!root) {
    root = ReactDOMClient.createRoot(container);
    containerRootMap.set(container, root);
  }
  root.render(node);
  return root;
}

const legacyReactDOM = {
  render(element, container, callback) {
    mountWithRoot(element, container);
    if (typeof callback === 'function') {
      callback();
    }
    return legacyReactDOM;
  },
  unmountComponentAtNode(container) {
    const root = containerRootMap.get(container);
    if (root) {
      root.unmount();
      containerRootMap.delete(container);
      return true;
    }
    return false;
  },
  findDOMNode() {
    throw new Error('findDOMNode is no longer supported.');
  },
};

unstableSetRender((node, container) => {
  const root = mountWithRoot(node, container);
  return () => {
    root.unmount();
    containerRootMap.delete(container);
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
  };
});

const resolveGlobalScope = () => {
  if (typeof window !== 'undefined') return window;
  if (typeof global !== 'undefined') return global;
  return Function('return this')();
};

const globalScope = resolveGlobalScope();

if (globalScope && typeof globalScope.ReactDOM === 'undefined') {
  globalScope.ReactDOM = legacyReactDOM;
}

export default legacyReactDOM;

